import Vue from "vue"

// Create a new Vue instance to use as an event bus
const eventBus = new Vue()

export default eventBus 